import React from 'react';
import { injectIntl } from 'react-intl';
import { isNotEmpty, parseClasses } from '../../lib/ep';
import { useCSS } from '../../lib/hooks';

export const PublicGameIntentionStats = (props) => {
	useCSS('comp/public_games_stats.css');

	const items = props?.items ?? [];
	const options = props?.options ?? ['ko', 'ok'];

	let classname = props?.classname ?? 'gui_simple_stats gui_simple_intention_bar_stats';
	classname = parseClasses(classname, props._class, 'stats_bar');

	const display_abs_stats = props?.display_abs_stats ?? false;

	return (
		<ul class={classname} style={props.styles}>
			{items.map((item, i) => {
				const total = item?.total ?? 0;

				const percentage_no = (total > 0) ? Math.round(item[options[0]] * 100 / total) : 0;
				const percentage_yes = (total > 0) ? Math.round(item[options[1]] * 100 / total) : 0;

				return (
					<li key={i}>
						<div class="is_bar no_selection">
							<span class="b_bar">
								<span class="c" style={{ width:`${percentage_no}%` }} />
							</span>

							<span class="b_percent">
								<span>{percentage_no}%</span>

								{(display_abs_stats) && (
									<span class="abs_stats">[{item[options[0]]}]</span>
								)}
							</span>
						</div>

						<div class="candidate">
							{(isNotEmpty(item, 'image')) && (
								<img class="b_img" src={item.image} alt={item.name} />
							)}
						</div>

						<div class="is_bar yes_selection">
							<span class="b_bar">
								<span class="c" style={{ width:`${percentage_yes}%` }} />
							</span>

							<span class="b_percent">
								<span>{percentage_yes}%</span>

								{(display_abs_stats) && (
									<span class="abs_stats">[{item[options[1]]}]</span>
								)}
							</span>
						</div>

						<strong class="b_label">{item.name}</strong>
					</li>
				)
			})}
		</ul>
	);
};

const PublicGameStats = (props) => {
	useCSS('comp/public_games_stats.css');

	const items = props?.items ?? [];
	const total = props?.total ?? 0;
	const is_multi = props?.is_multi ?? false;
	const colors = props?.colors ?? {};
	const options = (is_multi) ? (props?.options ?? ['ok', 'ko']) : ['value'];

	let classname = props?.classname ?? `gui_simple_stats gui_simple_bar_stats${(is_multi) ? ' is_multi' : ''}`;
	classname = parseClasses(classname, props._class, 'stats_bar');

	const actual_selection = props?.actual_selection ?? false;
	const display_abs_stats = props?.display_abs_stats ?? false;

	return (
		<ul class={classname} style={props.styles}>
			{items.map((item, i) => {
				let is_actual_selection;
				if(!is_multi) {
					is_actual_selection = (actual_selection !== false && actual_selection.id == item.id) ? true : false;
				} else {
					is_actual_selection = (actual_selection !== false && actual_selection[item.id] != undefined) ? true : false;
				}

				const percentage = (total > 0) ? Math.round(item.value * 100 / total) : 0;

				return (
					<li key={i}>
						<span class="b_index">{i + 1}</span>

						{(isNotEmpty(item, 'image')) && (
							<img class="b_img" src={item.image} alt={item.name} />
						)}

						<strong class="b_label">
							{(is_actual_selection) && (
								<span class="ep-check-list-item gui_small_icon selected_icon" />
							)}

							{item.name}

							{(display_abs_stats && !is_multi) && (
								<span class="abs_value">[{props.intl.formatMessage({ id:"{num} votes" }, { num:(item?.value ?? 0) })}]</span>
							)}
						</strong>

						<div class="bars">
							{options.map((option, o) => {
								let sub_total;
								let sub_percentage;

								if(!is_multi) {
									sub_total = total;
									sub_percentage = percentage;
								} else {
									sub_total = item.total;
									sub_percentage = (sub_total > 0) ? Math.round(item[option] * 100 / sub_total) : 0;
								}

								const bar_classes = ['b_bar'];
								if(o < 1) bar_classes.push('selectable');

								const bar_styles = {};
								if(isNotEmpty(colors, option)) bar_styles['--main-color'] = colors[option];

								return (
									<div key={`${i}_${option}`} class={`is_bar ${option}_selection`} style={bar_styles}>
										<span class={bar_classes.join(" ")}>
											<span class="c" style={{ width:`${sub_percentage}%` }} />
										</span>

										<span class="b_percent">
											{sub_percentage}%

											{(display_abs_stats && is_multi) && (
												<span class="abs_value">[{item?.value ?? 0}]</span>
											)}
										</span>
									</div>
								)
							})}
						</div>
					</li>
				)
			})}
		</ul>
	);
};

export default injectIntl(PublicGameStats);